import { render, staticRenderFns } from "./DeclareList.vue?vue&type=template&id=d098dd9e&scoped=true&"
import script from "./DeclareList.vue?vue&type=script&lang=js&"
export * from "./DeclareList.vue?vue&type=script&lang=js&"
import style0 from "./DeclareList.vue?vue&type=style&index=0&id=d098dd9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d098dd9e",
  null
  
)

export default component.exports